import { library, dom } from "@fortawesome/fontawesome-svg-core";
import {
  faBars as fasBars,
  faTimes as fasTimes,
  faPlayCircle as fasPlayCircle,
  faParking as fasParking,
  faMugHot as fasMugHot,
  faUtensils as fasUtensils,
  faSatelliteDish as fasSatelliteDish,
  faArrowsAltV as fasArrowsAltV,
  faWifi as fasWifi,
  faWind as fasWind,
  faCertificate as fasCertificate,
  faBuilding as fasBuilding,
  faBriefcase as fasBriefcase,
  faBus as fasBus,
  faTrain as fasTrain,
  faSubway as fasSubway,
  faSeedling as fasSeedling,
  faRoute as fasRoute,
  faRecycle as fasRecycle,
  faPlay as fasPlay,
  faFile as fasFile
} from "@fortawesome/pro-solid-svg-icons";
import {
  faChevronRight as falChevronRight,
  faChevronLeft as falChevronLeft,
  faMobile as falMobile,
  faBicycle as falBicycle
} from "@fortawesome/pro-light-svg-icons";
import {
  faFacebook as fabFacebook,
  faTwitter as fabTwitter,
  faLinkedin as fabLinkedin,
  faInstagram as fabInstagram
} from "@fortawesome/free-brands-svg-icons";
library.add(
  fasBars,
  fasTimes,
  fasPlayCircle,
  fasParking,
  fasMugHot,
  fasUtensils,
  falChevronRight,
  falChevronLeft,
  falMobile,
  falBicycle,
  fabFacebook,
  fabTwitter,
  fabInstagram,
  fabLinkedin,
  fasSatelliteDish,
  fasArrowsAltV,
  fasWifi,
  fasWind,
  fasCertificate,
  fasBuilding,
  fasBriefcase,
  fasBus,
  fasTrain,
  fasSubway,
  fasSeedling,
  fasRoute,
  fasRecycle,
  fasPlay,
  fasFile
);
dom.watch();
